import sanitizeHTML from 'sanitize-html';

/** @param {string} string */
export const sanitizeString = (string) => sanitizeHTML(string, { allowedTags: [], allowedAttributes: {} });
